import qs from 'qs'

export function convertQueryParamStringToObject(searchParams) {
  return qs.parse(searchParams, { ignoreQueryPrefix: true })
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/convertQueryParamStringToObject/index.js